import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { SessionType } from '@shared';
import { selectSession } from '@client/model';
import { useClerkClientAuth } from '@client/hooks/useClerkClientAuth';

export function AuthSignout() {
  const session = useSelector(selectSession);
  const isClient = session.sessionType === SessionType.client;
  const { clerkSignOut, clerkEmail } = useClerkClientAuth();

  useEffect(() => {
    const redirectUrl = isClient
      ? '/'
      : `/?email=${encodeURIComponent(clerkEmail ?? '')}`;
    clerkSignOut({ redirectUrl });
  }, []);

  return null;
}
